var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    class: [
      "status-indicator",
      `status-indicator--${_vm.size}`,
      `status-indicator--${_vm.color}`,
    ],
    attrs: { title: _vm.colorLabel },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }